import { gql } from '@apollo/client';

import type { CLIENT_BATTLE_TYPES } from '~/constants';

import type { IBattleType } from '~/types/declaration';

const battleTypes = gql`
  query BattleType($lang: String) {
    battleTypes(lang: $lang) {
      id
      name
      title
      description
      icons {
        default
      }
    }
  }
`;

export default battleTypes;

export type IBattleTypeData = {
  id: string;
  name: string;
  title: string;
  description: string;
  icons: {
    default: string;
  };
};

export type IBattleTypesData = {
  [key in IBattleType | CLIENT_BATTLE_TYPES]?: IBattleTypeData;
};

export type IBattleTypesResponse = {
  battleTypes: IBattleTypeData[];
};
